<main id="main-content" class="main-content">
    <h2 class="form-header">Signatures & Certifications:</h2>
    <mat-card *ngFor="let forest of report().forests">
        <div class="title">{{ forest.forest_name }}
            <mat-chip *ngIf="forest.signature != null" class="chip-4">SIGN & CERTIFIED</mat-chip> 
            <mat-chip *ngIf="forest.signature == null" class="chip-high">NEEDS SIGNATURE</mat-chip> 
        </div>
        <div class="whole-line">
            <div class="quarter-div">
                <p class="data-title">Signed and Certified on</p>
                <p class="data-info">
                    {{ forest.signature?.created_on | date:"MM/dd/yyyy" | empty_check }}
                </p>
            </div>
            <div class="quarter-div">
                <p class="data-title">Signed By</p>
                <p class="data-info">{{ forest.signature?.name ?? "--" }}</p>
            </div>
            <div class="quarter-div">
                <p class="data-title">Title</p>
                <p class="data-info">{{ forest.signature?.title ?? "--" }}</p>
            </div>
        </div>
    </mat-card>
</main>